import { useState, useEffect } from 'react';

export function useDetectPrint() {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(
    () => {
      const mediaQueryList = global.window.matchMedia('print');

      const handlePrintChange = (mql: MediaQueryListEvent) => {
        setIsPrinting(mql.matches);
      };

      const handleBeforePrint = () => {
        setIsPrinting(true);
      };

      const handleAfterPrint = () => {
        setIsPrinting(false);
      };
      mediaQueryList.addEventListener('change', handlePrintChange);
      global.window.addEventListener('beforeprint', handleBeforePrint);
      global.window.addEventListener('afterprint', handleAfterPrint);
      //   global.document.body.classList.add("is-print-version");

      return () => {
        mediaQueryList.removeEventListener('change', handlePrintChange);
        global.window.removeEventListener('beforeprint', handleBeforePrint);
        global.window.removeEventListener('afterprint', handleAfterPrint);
        // global.document.body.classList.remove("is-print-version");
      };
    },
    [
      //   isSet
    ],
  );

  return isPrinting;
}
